import React, { Component } from "react";
import PropTypes from "prop-types";
import Textarea from "react-textarea-autosize";

class SendMessageForm extends Component {
  constructor() {
    super();

    this.state = {
      message: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({
      message: e.target.value
    });
  }

  handleSubmit(e, channelId, message, sendMessage) {
    e.preventDefault();
    const text_length = message.replace(/\n/g, "").length;
    if (text_length > 0) {
      sendMessage(channelId, message);
      this.setState({
        message: ""
      });
    }
  }

  render() {
    const { channelId, sendMessage } = this.props;
    const { message } = this.state;
    const disabled = !channelId;

    return (
      <form data-remote='true'>
        <div className='type-msg'>
          <div className='input-msg-write d-flex align-items-start'>
            <Textarea
              style={{lineHeight: 2, resize: "none"}}
              placeholder='メッセージを入力'
              disabled={disabled}
              onChange={this.handleChange}
              value={message}
            />
            <button
              onClick={(e) => this.handleSubmit(e, channelId, message, sendMessage)}
              className='btn btn-primary btn-msg-send'
              type='button'
              disabled={message == ""}
            >
              送信
            </button>
          </div>
        </div>
      </form>
    );
  }
}

SendMessageForm.propTypes = {
  channelId: PropTypes.number,
  sendMessage: PropTypes.func.isRequired
};

SendMessageForm.defaultProps = {
  channelId: null
};

export default SendMessageForm;
